import styled, { css } from 'styled-components';
import { Box } from '../../../../ui-kit';

export const ItemListWrapper = styled(Box)`
  ${({ allowPackageUpdate }) => {
    if (!allowPackageUpdate) {
      return css`
        & > div {
          margin-top: 0;
          margin-bottom: 4px;
        }
      `;
    }
  }}
`;
